module.exports = {
  $vuetify: require('vuetify/es5/locale/en').default,
  Lang: {
    change: 'Change the language',
    name: 'English',
    iso: 'en_US'
  },
  Action: {
    add: 'Add',
    edit: 'Edit',
    remove: 'Remove',
    close: 'Close',
    select: 'Select',
    save: 'Save',
    saving: 'Saving',
    send: 'Send',
    confirmSelection: 'Confirm selection',
    change: 'Change',
    changeSelection: 'Change selection',
    next: 'Next',
    prev: 'Previous',
    finish: 'Finish',
    search: 'Search',
    print: 'Print',
    returnToList: 'Return to list',
    goToCart: 'Go to cart',
    clearCart: 'Clear cart',
    placeOrder: 'Place order',
    addToCart: 'Add to cart',
  },
  Common: {
    category: 'Category',
    date: 'Date',
    creationdate: 'Creation date',
    lastmodified: 'Last modified',
    status: 'Status',
    color: 'Color',
    settings: 'Settings',
    filterText: 'Filter text',
    masterdata: 'Master data',
    masterdataSaved: 'Master data saved',
    price: 'Price',
    amount: 'Amount',
    description: 'Description',
    item: 'Item',
    itemNum: 'Item no.',
    itemName: 'Item name',
    itemPrice: 'Item price',
    quantity: 'Quantity',
    singlePrice: 'Sellingprice',
    discount: 'Discount',
    rebate: 'Rebate',
    netAmount: 'Net amount',
    taxAmount: 'Tax amount',
    taxPercent: 'Tax (%)',
    grossAmount: 'Gross amount',
    total: 'Total',
    orderPrice: 'Order price',
    annotation: 'Annotation',
    accountDetails: 'Account details',
    customerNum: 'Customer no.',
    salutation: 'Title',
    firstname: 'Firstname',
    lastname: 'Lastname',
    company: 'Company',
    email: 'Email',
    contact: 'Contact',
    address: 'Addresse',
    postalcode: 'Postalcode',
    city: 'City',
    country: 'Country',
    taxDetails: 'Tax details',
    vatId: 'VAT ID',
    noEntries: 'No entries',
    languageSettings: 'Language settings',
    showXtoYentries: 'Showing {x} to {y} results',
    showXtoYofZentries: 'Showing {x} to {y} out of {z} results',
    errorSavingMasterdata: 'Could not save masterdata.',
    errorIncomplete: 'Incomplete form',
    errorFieldMissing: '{field} is missing',
    errorUploadInvalidResp: 'Invalid server response. Please try again or contact our support.',
    name: 'Name',
    filename: 'File Name',
    ticketnum: 'Ticket Num',
    duedate: 'Due date',
    ouragent: 'Our Agent',
    nickname: 'Nickname',
    orderedOnly: 'Ordered Only',
    favoritesOnly: 'Favorites Only',
    sortBy: 'Sort By',
  },
  Units: {
    C62: 'pcs.',
    GRM: 'g'
  },
  Application: {
    application: 'Application',
    cart: 'Cart',
    shop: 'Shop',
    orders: 'Orders',
    billing: 'Billing',
    dashboard: 'Dashboard',
    tickets: 'Tickets',
    notes: 'Notes',
    reports: 'Reports',
    deliveries: 'Deliveries',
    offers: 'Offers',
    invoices: 'Invoices',
  },
  Addresses: {
    title: 'Addresses',
    add: 'New Address',
    addressMain: 'Main address',
    addressBilling: 'Billing address',
    addressShipping: 'Shipping address',
    confirmRemove: 'Do you really want to remove this address?',
    errorLoad: 'Address could not be loaded.',
    errorRemove: 'Address could not be removed.'
  },
  EditAddress: {
    title: 'New Address',
    errorTypeTitle: 'Please specify an address type.',
    errorTypeText: 'The address must be a billing and/or shipping address.',
    errorCreate: 'Could not create address.',
    errorUpdate: 'Could not update address',
    shipping: 'Shipping',
    useForShippingNo: 'Do not use for shipping',
    useForShippingYes: 'Use as shipping address',
    useForShippingDefault: 'Use as default shipping address',
    billing: 'Billing',
    useForBillingNo: 'Do not use for billing',
    useForBillingYes: 'Use as billing address',
    useForBillingDefault: 'Use as default billing address'
  },
  Cart: {
    PlaceOrder: {
      title: 'Please, carefully review and confirm your order',
      text: 'I have reviewed my order and confirm the <a href="{0}" target="_blank">terms of service</a>',
      cancel: 'Cancel',
      confirm: 'Place order'
    }
  },
  Orders: {
    loading: 'Loading orders',
    currentOrders: 'Current orders',
    openOrder: 'Open order',
    showAll: 'Show all orders',
    noOrders: 'No orders',
    orderNum: 'Order no.',
    projectRef: 'Project ref.',
    statusAll: 'All orders',
    statusReceived: 'Received',
    statusReceivedDescr: 'Your order is being reviewed',
    statusInProgress: 'In progress',
    statusInProgressDescr: 'Your order is being processed',
    statusInProduction: 'In production',
    statusInProductionDescr: 'Production has started',
    statusOnHold: 'On hold',
    statusCancelled: 'Cancelled',
    statusCancelledDescr: 'Your order has been cancelled',
    statusClosed: 'Closed',
    statusCompleted: 'Completed',
    statusInvoicedCancelled: 'Invoiced / cancelled',
    statusPartlyDelivered: 'Partly delivered',
    statusPartlyDeliveredCancelled: 'Partly delivered / cancelled',
    statusPartlyDeliveredClosed: 'Partly delivered / closed',
    statusDelivered: 'Delievered',
    statusReadyForPickup: 'Ready for pickup',
    errorCouldNotLoad: 'Could not load order'
  },
  OrderDetails: {
    title: 'Order details',
    deliveryNote: 'Delivery note',
    loading: 'Loading order',
    trackingNum: 'Tracking no.',
    manufacturingStatus: 'Manufacturing status',
    trackingAndBilling: 'Tracking and billing',
    creatingOrder: 'Creating order',
    orderProject: 'Order project',
    acceptTerms: 'I have read and accepted the <a href="{termsUrl}" target="_blank">Terms of Service</a>.',
    errorNoOrderNum: 'Invalid order number',
    errorCouldNotLoad: 'Could not load order',
    priceNobleMetal1: 'The final product price for noble metals is calculated based on the product\'s final weight.',
    priceNobleMetal2: 'Please check your delivery note once you receive the shippment for further details.'
  },
  Invoices: {
    title: 'Invoices',
    loading: 'Loading invoices',
    invoiceNum: 'Invoice no.',
    monthlyStatement: 'Monthly statement',
    statusReceived: 'Received',
    statusOpen: 'Open',
    statusHold: 'On hold',
    statusCancelled: 'Cancelled',
    statusClosed: 'Closed',
    statusPartlyPaid: 'Partly paid',
    statusPartlyPaidCancelled: 'Partly paid / cancelled',
    statusPartlyPaidClosed: 'Partly paid / closed',
    statusPaid: 'Paid',
    pinCodeTitle: 'Please enter the {0}-digit PIN code',
    invalidPinCode: 'Invalid pin code.'
  },
  Messages: {
    title: 'Messages',
    noMessages: 'No messages',
    writeSomething: 'Write something...',
    errorSendingMessage: 'Error sending message.'
  },
  File: {
    name: 'File name',
    hash: 'File hash',
    messageUpload: 'Click field or drag/drop file to upload',
    allFilesSameMaterial: 'All files have the same material',
    sendingData: 'Sending data',
    processingData: 'Processing data',
    errorUpload: 'An error occured. Could not upload file.',
    errorCouldNotList: 'Could not load files.',
    errorCouldNotLoad: 'Could not load file.',
    errorCouldNotDelete: 'Could not delete files.'
  },
  Login: {
    username: 'Email or customer number',
    password: 'Password',
    passwordOld: 'Old password',
    passwordNew: 'New password',
    passwordConfirm: 'Confirm new password',
    passwordSaved: 'Password updated',
    staySignedIn: 'Stay signed in',
    login: 'Login',
    logout: 'Logout',
    enterPwd: 'Please enter your password',
    invalidUserOrPwd: 'Invalid username or password',
    errorCouldNotUpdate: 'Could not update password.',
    errorPasswordNoMatch: 'Passwords do not match.',
    errorOldPassword: 'Your old password is wrong.',
    errorNoSession: 'No active user session found. Please log in.',
    instance: 'Instance',
  },
  ChangePin: {
    title: 'Change Pin',
    invalidOldPin: 'Invalid Old Pin',
    old: 'Old',
    new: 'New',
    change: 'Change Pin',
  },
  ChangePassword: {
    title: 'Change Password',
    invalidOldPassword: 'Invalid Old Password',
    old: 'Old',
    new: 'New',
    change: 'Change Password',
  },
  Tickets: {
    Tasks: 'Tasks',
    Messages: 'Messages',
    Actions: 'Actions',
    History: 'History',
    BillingItems: 'Service items',
  },
  Transactions: {
    Cart: 'Cart'
  }
};
